import type { AxiosError } from "axios";
import type { UseQueryResult } from "react-query";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";

import apiBase from "../../utils/apiBase";

interface IMember {
  firstName?: string;
  lastName?: string;
  userId: string;
}
export interface IResponseUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  state: string;
  emailConfirmed: boolean;
  twoFactorEnabled: boolean;
  registrationDate: string;
  roles: {
    name: string;
  }[];
  organizations: {
    id: string;
    name: string;
    roles: {
      name: string;
    }[];
    joinedAt: string;
  }[];
  providers: string[];
}

const getUserData = async (data: {
  userId: string;
  organizationId: string;
}): Promise<any> => {
  const res = await apiBase.get(
    `users/${data.userId}/organizations/${data.organizationId}`,
  );
  return res;
};

const patchUser = async (data: any): Promise<any> => {
  return await apiBase.patch(`users/${data.userId}`, {
    firstName: data.firstName,
    lastName: data.lastName,
  });
};

const resetPassword = async (userId: string, orgId: string): Promise<any> => {
  if (!userId && !orgId) {
    return;
  }
  return await apiBase.post(
    `users/${userId}/reset-password?organizationId=${orgId}`,
  );
};

export const usePatchUser = () => {
  return useMutation<IResponseUser, AxiosError, IMember>(patchUser, {
    onSuccess: () => {
      toast.success("User updated successfully!");
    },
  });
};

export const useGetUser = (data: {
  userId: string;
  organizationId: string;
}): UseQueryResult<any> => {
  return useQuery(
    ["users", data.userId, data.organizationId],
    () => getUserData(data),
    {
      enabled: !!data.organizationId && !!data.userId,
    },
  );
};

export const useResetPassword = (
  userId: string,
  orgId: string,
): UseQueryResult<any> => {
  return useQuery(
    ["resetPassword", userId],
    () => resetPassword(userId, orgId),
    {
      enabled: false,
      onSuccess: () => {
        toast.success("We have sent a password reset email to your email!");
      },
    },
  );
};
